// function to get the abbreviation of a number like 1985 can be converted to 1.9K, 100003434 can be converted to 100M, etc.
export function getNumberAbbreviation(num: number): string {
  // Handle invalid inputs that could cause NaN
  if (num == null || isNaN(num) || num === 0) {
    return '0'
  }

  const positiveNumber = Math.abs(num)
  const SI_SYMBOL = ['', 'K', 'M', 'G', 'T', 'P', 'E']
  // what tier? (determines SI symbol)
  const tier = (Math.log10(positiveNumber) / 3) | 0
  // if zero, we don't need a suffix
  if (tier === 0) return positiveNumber.toString()

  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier]
  const scale = Math.pow(10, tier * 3)
  // scale the number
  let scaled = positiveNumber / scale
  scaled = Math.floor(scaled * 10) / 10

  // format number and add suffix
  const formattedNumber =
    scaled % 1 === 0 ? scaled.toFixed(0) : scaled.toFixed(1)

  if (formattedNumber.length > 4) {
    return formattedNumber.slice(0, 3) + suffix
  }
  return formattedNumber + suffix
}
